import { CartAddEvent } from '@theme/events';

document.addEventListener('moast-cart-add', async (event) => {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    document.dispatchEvent(
      new CartAddEvent(cart, 'moast-cart-add', {
        source: 'moast',
        itemCount: cart.item_count,
        variantId: event.detail?.variantId?.toString(),
      })
    );
  } catch (error) {
    console.error('Failed to refresh cart after Moast add:', error);
  }
});
